<section>
    <app-header
        [title]="'create-claim.register_new_claim' | translate"
        [backLinkText]="'create-claim.go_back_home' | translate"
        [backLinkGtmLabel]="'claim-funnel_link_back-to--claims'"
        (onBackLinkClick)="goBack()"
    />

    <div class="mx-4 md:mx-8">
<!--        Progress Bar Component-->
        <div class="mt-3 mb-1">
            <app-progress-bar
                [noAbsoluteText]="true"
                [steps]="steps"
            ></app-progress-bar>
        </div>

<!--        Components to display the current tab content based on the selected tab-->
        <div *ngIf="isInitialLoadingDone" class="mb-6">
            <app-claim-info
                *ngIf="tabInfo.currentTab === 'claim-info'"
                [claimInformation]="newClaim"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
                (onContinueState)="canContinue = $event"
            />
            <app-claim-material-selection
                *ngIf="tabInfo.currentTab === 'material-selection' || tabInfo.currentTab === 'material-edit-area'"
                [userInfo]="userInfo"
                [claimInformation]="newClaim"
                [relatedFabricators]="relatedFabricators"
                [materialsSelected]="tabInfo.currentTab === 'material-edit-area'"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
                (continueState)="canContinue = $event"
            />
            <app-claim-classification
                *ngIf="tabInfo.currentTab === 'classification'"
                [claimInformation]="newClaim"
                [userInfo]="userInfo"
                [nextStepWarranty]="needWarranty"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
                (needWarranty)="$event ? addWarrantyStep() : removeWarrantyStep()"
                (onContinueState)="canContinue = $event"
            />
            <app-claim-warranty
                *ngIf="tabInfo.currentTab === 'warranty' || tabInfo.currentTab === 'warranty-agreement'"
                [userInfo]="userInfo"
                [claimInformation]="newClaim"
                [warrantyAgreementOpen]="tabInfo.currentTab === 'warranty-agreement'"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
                (onContinueState)="canContinue = $event"
            />
            <app-claim-documentation
                *ngIf="tabInfo.currentTab === 'documentation'"
                [userInfo]="userInfo"
                [claimInformation]="newClaim"
                [previousStepWarranty]="needWarranty"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
                (onContinueState)="canContinue = $event"
            />
            <app-claim-summary-on-creation
                *ngIf="tabInfo.currentTab === 'summary'"
                [claimId]="newClaim.claimInfo.id!"
                (tabInit)="onTabInit($event)"
                (updateClaim)="onClaimUpdate($event)"
            />
        </div>

<!--        Buttons to navigate between tabs and save the draft-->
        <div class="p-8 bg-white border-divider border flex flex-wrap gap-3 justify-between">
            <div class="basis-full md:basis-0">
                <app-button
                    *ngIf="tabInfo.previousTab"
                    [block]="true"
                    [textWrap]="false"
                    (onClick)="goToPrevTab()"
                >{{'create-claim.prev_step' | translate}}</app-button>
            </div>
            <div class="flex flex-wrap gap-3 basis-full items-center md:basis-0 md:flex-nowrap">
                <div class="basis-full md:basis-0">
                    <app-button
                        [ghost]="true"
                        [block]="true"
                        [textWrap]="false"
                        (onClick)="saveDraft(true)"
                    >{{'create-claim.exit_and_save_draft' | translate}}</app-button>
                </div>
                <div class="basis-full md:basis-0">
                    <app-button
                        *ngIf="tabInfo.nextTab"
                        [primary]="true"
                        [disabled]="!canContinue"
                        [block]="true"
                        [textWrap]="false"
                        (onClick)="goToNextTab()"
                    >{{ getButtonLabel() | translate }}</app-button>
                </div>
            </div>
        </div>
    </div>

    <div
    *ngIf="showFinishModal"
    class="finish-modal__overlay"
    role="dialog"
    aria-modal="true"
    aria-labelledby="finishModalTitle"
    (click)="closeFinishModal()"
>
    <div class="finish-modal__panel" (click)="$event.stopPropagation()">
        <button
            class="finish-modal__close"
            type="button"
            aria-label="Close"
            (click)="closeFinishModal()">×
        </button>

        <ng-container>
            <span id="finishModalTitle" class="typography-title-m">
                {{ 'my_claims.popup_title' | translate  }}
            </span>

            <p class="typography-body-l-regular">
                {{ 'my_claims.popup_subtitle' | translate }}
            </p>

            <div class="w-full flex justify-center mt-6">
                <app-button
                    [primary]="true"
                    (onClick)="closeFinishModal()"
                >{{ 'my_claims.popup_button' | translate }}</app-button>
            </div>
        </ng-container>
    </div>
</div>
</section>